import React from "react";
import styled from "styled-components";
import { SortDir } from "spraypaint/lib-esm/scope";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import Th, { THProps } from "./Th";

interface SortableThProps extends Omit<THProps, "onClick"> {
  children: string;
  onClick: (name: string) => void;
  name: string;
  dir?: SortDir;
}

const SortableTh = (props: SortableThProps) => {
  const { children, onClick, name, dir } = props;

  return (
    <Wrapper
      collapse={props.collapse}
      data-tip={`Sort by ${children.toLowerCase()}`}
      onClick={() => onClick(name)}
    >
      <Contents>
        {children}{" "}
        <SortGroup>
          <SortIcon dir="asc" active={dir === "asc"} />
          <SortIcon dir="desc" active={dir === "desc"} />
        </SortGroup>
      </Contents>
    </Wrapper>
  );
};

type SortIconProps = {
  dir: SortDir;
  active: boolean;
};

const SortIcon = ({ dir, active }: SortIconProps) => {
  const icon = dir === "desc" ? faChevronDown : faChevronUp;
  return <Icon icon={icon} active={active} />;
};

const SortGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
`;

const Icon = styled(FontAwesomeIcon)<{ active: boolean }>`
  font-size: 12px;
  margin: 0 0.5rem;
  color: ${({ active, theme }) =>
    active ? theme.colors.text : theme.colors.gray300};
`;

const Contents = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Wrapper = styled(Th)`
  transition: background-color 80ms ease-in;
  cursor: pointer;

  :hover {
    background-color: ${({ theme }) => theme.colors.gray200};
  }
`;

export default SortableTh;
